/*
  mb-link-vorladen.js — Links vorladen, bevor geklickt wird
  MaxiBricks, 25.10.2026

  Eigener Ersatz fuer assets/tiny-img-link-preloader.js, das die App TinySEO
  ins Theme geschrieben hatte (ein minifizierter instant.page-Klon). Gleiche
  Grundidee, aber lesbar, mit deutschen Kommentaren und mit mehr Pfaden auf
  der Sperrliste.

  Verhalten
  ---------
  Zeigt die Maus 65 ms auf einen internen Link oder wird er angetippt, laedt
  der Browser das Ziel per <link rel="prefetch"> im Hintergrund. Klickt der
  Besucher dann wirklich, ist die Seite meist schon da. Verlaesst der Zeiger
  den Link vorher wieder, wird das Vorladen abgebrochen.

  Bewusst NICHT vorgeladen
  ------------------------
  - fremde Domains, alles ausser http/https, https -> http
  - Warenkorb, Kasse, Konto, App-Proxys (/cart, /checkout, /account, /a/, …)
  - URLs mit Query-String (Filter, Sortierung, Tracking) — sonst waermt man
    Varianten auf, die kaum jemand zweimal aufruft
  - Sprunganker auf der aktuellen Seite
  - Downloads und target="_blank"
  - Links mit data-no-instant

  Rücksicht
  ---------
  Kein Vorladen bei aktivem Datensparmodus (Save-Data), bei
  prefers-reduced-data: reduce oder auf 2G. Pro Seitenaufruf maximal
  GRENZE Ziele, damit langes Scrollen durch eine Kategorie nicht hundert
  Anfragen erzeugt.
*/
(function () {
  'use strict';

  var VERZOEGERUNG = 65; // ms, die der Zeiger auf dem Link stehen muss
  var TOUCH_SPERRE = 1100; // ms, in denen nach Touch kein mouseover zaehlt
  var GRENZE = 50; // Vorladevorgaenge pro Seitenaufruf

  var sperrliste = [
    '/cart',
    '/checkout',
    '/account',
    '/admin',
    '/a/',
    '/apps/',
    '/tools/',
    '/services/',
    '/password',
    '/challenge'
  ];

  var vorlader = document.createElement('link');
  var unterstuetzt =
    vorlader.relList && vorlader.relList.supports && vorlader.relList.supports('prefetch');
  if (!unterstuetzt) return;

  var verbindung = navigator.connection || {};
  if (verbindung.saveData) return;
  if (typeof verbindung.effectiveType === 'string' && /^(slow-)?2g$/.test(verbindung.effectiveType)) return;
  try {
    if (window.matchMedia('(prefers-reduced-data: reduce)').matches) return;
  } catch (e) {
    /* aeltere Browser kennen die Abfrage nicht — dann einfach weiter */
  }

  vorlader.rel = 'prefetch';
  document.head.appendChild(vorlader);

  var aktuellesZiel;
  var wartezeit;
  var letzterTouch = 0;
  var anzahl = 0;
  var erledigt = Object.create(null);

  function geeignet(link) {
    if (!link || !link.href) return false;
    if (link.hasAttribute('download')) return false;
    if (link.target && link.target !== '_self') return false;
    if ('noInstant' in link.dataset) return false;
    if (aktuellesZiel === link.href) return false;
    if (erledigt[link.href]) return false;

    var ziel;
    try {
      ziel = new URL(link.href);
    } catch (e) {
      return false;
    }

    if (ziel.origin !== location.origin) return false;
    if (ziel.protocol !== 'http:' && ziel.protocol !== 'https:') return false;
    if (ziel.protocol === 'http:' && location.protocol === 'https:') return false;
    if (ziel.search) return false;
    if (ziel.hash && ziel.pathname + ziel.search === location.pathname + location.search) return false;
    if (ziel.pathname === location.pathname && !ziel.search) return false;

    for (var i = 0; i < sperrliste.length; i++) {
      if (ziel.pathname === sperrliste[i] || ziel.pathname.indexOf(sperrliste[i]) === 0) return false;
    }

    return true;
  }

  function vorladen(url) {
    if (anzahl >= GRENZE) return;
    anzahl++;
    erledigt[url] = true;
    vorlader.href = url;
  }

  function abbrechen() {
    vorlader.removeAttribute('href');
  }

  function beiTouch(ereignis) {
    letzterTouch = performance.now();
    var link = ereignis.target.closest && ereignis.target.closest('a');
    if (!geeignet(link)) return;
    aktuellesZiel = link.href;
    vorladen(link.href);
  }

  function beiMouseover(ereignis) {
    if (performance.now() - letzterTouch < TOUCH_SPERRE) return;
    var link = ereignis.target.closest && ereignis.target.closest('a');
    if (!geeignet(link)) return;
    link.addEventListener('mouseout', beiMouseout, { passive: true });
    aktuellesZiel = link.href;
    wartezeit = setTimeout(function () {
      vorladen(link.href);
      wartezeit = undefined;
    }, VERZOEGERUNG);
  }

  function beiMouseout(ereignis) {
    var von = ereignis.target.closest && ereignis.target.closest('a');
    var nach = ereignis.relatedTarget && ereignis.relatedTarget.closest && ereignis.relatedTarget.closest('a');
    if (von && nach && von === nach) return;
    if (wartezeit) {
      clearTimeout(wartezeit);
      wartezeit = undefined;
    } else {
      aktuellesZiel = undefined;
      abbrechen();
    }
  }

  var optionen = { capture: true, passive: true };
  document.addEventListener('touchstart', beiTouch, optionen);
  document.addEventListener('mouseover', beiMouseover, optionen);
})();
